import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { PositioningText } from './PositioningText'
import { getItemUrl } from 'LiveBoard/components/shared/itemUrlHelper'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const Positioning = (props) => {

  const location = useLocation()
  const LeadingItemComponent = props.leadingItemComponent

  const hasPositioningText = !isEmpty(props.config.title) || !isEmpty(props.config.text)

  const leadingItemParams = {
    item: props.leadingItem,
    queryString: location.search
  }

  const handleLeadingItemClick = () => {
    props.onItemClick(leadingItemParams)
  }

  const getLeadingItemUrl = () => {
    return getItemUrl({
      ...leadingItemParams,
      board: props.board
    })
  }

  return (hasPositioningText || (props.hasLeadingItem && props.leadingItemAvailable)) && (
    <div className="positioning-wrapper">
      <div className="positioning-container">
        { hasPositioningText &&
            <PositioningText
              config={{...props.config}}
              themeColorHex={props.themeColorHex}
              hasLeadingItem={props.leadingItemAvailable} />
        }
        { props.leadingItemAvailable && (
          <LeadingItemComponent
            config={props.leadingItem}
            gatingEnabled={props.gatingEnabled}
            themeColorHex={props.themeColorHex}
            showItemDescription={props.showItemDescription}
            onClick={handleLeadingItemClick}
            leadingItemUrl={getLeadingItemUrl()} />
        )}
      </div>
    </div>
  )
}

Positioning.propTypes = {
  config: PropTypes.object.isRequired,
  board: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  hasLeadingItem: PropTypes.bool.isRequired,
  leadingItemAvailable: PropTypes.bool.isRequired,
  leadingItem: PropTypes.object,
  gatingEnabled: PropTypes.bool,
  showItemDescription: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired
}

Positioning.defaultProps = {
  config: {}
}

export default Positioning
